import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "onScroll"];
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default class UITypeaheadResults extends PureComponent {
  render() {
    const _this$props = this.props,
      {
        children,
        className,
        onScroll
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx("ul", Object.assign({}, rest, {
      className: classNames('private-typeahead-results', className),
      onScroll: onScroll,
      role: "listbox",
      children: children
    }));
  }
}
UITypeaheadResults.displayName = 'UITypeaheadResults';
UITypeaheadResults.propTypes = {
  children: PropTypes.node,
  onScroll: PropTypes.func
};